export const NAV_BAR = "NAV_BAR";
